import { ADMIN_TYPES } from "services/types";
import { unionBy, uniqBy } from "lodash";

const INITIAL_STATE = {
  getRotoListingResp: [],
  getRotoListingLoading: false,

  rotoDetails: {
    items: [],
    totalCount: 0,
  },

  addRotoResp: [],
  addRotoLoading: false,

  updateRotoResp: [],
  updateRotoLoading: false,
};

export default function rotoReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // listing
    case ADMIN_TYPES.ROTO_TYPE_LISTING_INIT:
      return {
        ...state,
        getRotoListingResp: [],
        getRotoListingLoading: true,
      };

    // case ADMIN_TYPES.ROTO_TYPE_LISTING_SUCCESS:
    //   return {
    //     ...state,
    //     getRotoListingResp: action.payload,
    //     getRotoListingLoading: false,
    //   };
    case ADMIN_TYPES.ROTO_TYPE_LISTING_SUCCESS:
      return {
        ...state,
        rotoDetails: {
          items: action.payload.item2,
          totalCount: action.payload.item1,
        },
        getRotoListingLoading: false,
      };

    case ADMIN_TYPES.ROTO_TYPE_LISTING_LOAD_MORE_SUCCESS:
      return {
        ...state,
        rotoDetails: state.rotoDetails
          ? {
              items: uniqBy(
                state.rotoDetails?.items.concat(action.payload.item2),
                "id"
              ),
              totalCount: action.payload.item1,
            }
          : {
              items: action.payload.item2,
              totalCount: action.payload.item1,
            },
        getRotoListingLoading: action.payload ? false : true,
      };

    case ADMIN_TYPES.ROTO_TYPE_LISTING_FINISH:
      return {
        ...state,
        getRotoListingLoading: false,
      };

    // add
    case ADMIN_TYPES.ROTO_TYPE_ADD_INIT:
      return {
        ...state,
        addRotoResp: [],
        addRotoLoading: true,
      };

    case ADMIN_TYPES.ROTO_TYPE_ADD_SUCCESS:
      const updatedListAfterAdd = [
        action.payload,
        ...state?.rotoDetails?.items,
      ];

      return {
        ...state,
        addRotoLoading: false,
        rotoDetails: {
          items: updatedListAfterAdd,
          totalCount: state?.rotoDetails?.totalCount + 1,
        },
      };

    case ADMIN_TYPES.ROTO_TYPE_ADD_FINISH:
      return {
        ...state,
        addRotoLoading: false,
      };

    // update
    case ADMIN_TYPES.ROTO_TYPE_UPDATE_INIT:
      return {
        ...state,
        updateRotoLoading: true,
      };

    case ADMIN_TYPES.ROTO_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        updateRotoLoading: false,
        updateRotoResp: action?.payload,
        rotoDetails: {
          items: state?.rotoDetails?.items
            ?.map((item) => {
              if (item.id === action.payload?.id) {
                return { ...action.payload };
              } else {
                return {
                  ...item,
                };
              }
            })
            .filter((item) => item !== null),
          totalCount: state?.rotoDetails?.totalCount,
        },
      };

    case ADMIN_TYPES.ROTO_TYPE_UPDATE_FINISH:
      return {
        ...state,
        updateRotoLoading: false,
      };

    default:
      return {
        ...state,
      };
  }
}
